import React, { FC } from 'react';
import { useTranslation } from '~/shared/utils/translation';
import { Button } from '~/shared/components';
import Flex from '~/shared/components/Flex';
import clsx from 'clsx';
import styles from '~/features/productList/components/RefinementListRow/RefinementListRow.module.scss';

type Props = {
    label?: string;
};

export const RefinementEmptyList: FC<Props> = (props) => {
    const { translate } = useTranslation();
    return (
        <Flex grow className={styles.dropdownItemContainer}>
            <Button
                className={clsx(styles.dropdownItemButton, styles.isDisabled)}
                fullWidth
                variant="plain"
                disabled
            >
                <Flex className={styles.dropdownItemText}>
                    <b>{props.label || translate('plp.noMatchFound')}</b>
                </Flex>
            </Button>
        </Flex>
    );
};

export default RefinementEmptyList;
